import { render, staticRenderFns } from "./newsDialog.vue?vue&type=template&id=06382748&scoped=true&"
import script from "./newsDialog.vue?vue&type=script&lang=js&"
export * from "./newsDialog.vue?vue&type=script&lang=js&"
import style0 from "./newsDialog.vue?vue&type=style&index=0&id=06382748&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06382748",
  null
  
)

export default component.exports